import { AngularFireAuth } from '@angular/fire/auth';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ApolloModule, Apollo, APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLinkModule, HttpLink } from 'apollo-angular-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import { onError } from 'apollo-link-error';
import { Observable } from 'apollo-link'; // <-- Add Observable
import * as firebase from 'firebase/app';




// graphQL Errors
const link = onError(({response, graphQLErrors, networkError, operation, forward }) => {

  // refreshing a token with apollo-client + firebase auth
  let access_token = localStorage.getItem('token');
  if (graphQLErrors) {
    if (access_token && access_token !== 'undefined') {
      if (response.errors[0].extensions.code === 'invalid-jwt') {

        console.log("Refresh token has expired")
        return new Observable(observer => {
          firebase
          .auth()
          .currentUser.getIdToken(true)
          .then( token => {
  
            if (!token) {
              localStorage.removeItem('token')
            }
            localStorage.setItem('token', token)
  
  
            // reset the headers
            operation.setContext(({ headers = {} }) => ({
              headers: {
                // Re-add old headers
                ...headers,
                // Switch out old access token for new one
                'login-token': token || null
              }
            }));
  
            const subscriber = {
              next: observer.next.bind(observer),
              error: observer.error.bind(observer),
              complete: observer.complete.bind(observer)
            };
  
            // Retry last failed request
            forward(operation).subscribe(subscriber);
  
  
          }).catch(error => {
            // No refresh or client token available, we force user to login
            observer.error(error);
          });
        })
      }
    }

    graphQLErrors.forEach(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );

    if (networkError) console.log(`[Network error]: ${networkError}`);

  }
});



const authCtx = (auth: AngularFireAuth) => setContext(async () => {


  if (!! localStorage.getItem('token') && localStorage.getItem('verification') === 'true'){
    
        let token = localStorage.getItem('token');
        // const token = getItem('token');
        // const token  =  await auth.idToken.pipe(take(1)).toPromise();

        return {
          headers: {
            Authorization: `Bearer ${token}`
          },
        }
      
      } else {
        return {
          headers: {

          },
        }
      }




  // const token  =  await auth.idToken.pipe(take(1)).toPromise();
  // let token = localStorage.getItem('token');
  // return {
  //   headers: {
  //     Authorization: `Bearer ${token}`
  //   }
  // }
})

// const uri = 'https://qaysar.herokuapp.com/v1/graphql';
const uri = 'https://api.qaysarpizza.com/v1/graphql';

export function creatApollo(httpLink: HttpLink, auth: AngularFireAuth) {
  return {
    link : ApolloLink.from([authCtx(auth), link, httpLink.create({ uri })]),
    cache : new InMemoryCache()
  }
}





// export function provideApollo(httpLink: HttpLink) {
//   const basic = setContext((operation, context) => ({
//     headers: {
//       Accept: 'charset=utf-8'
//     }
//   }));

//   // Get the authentication token from local storage if it exists
//   if (!! localStorage.getItem('token')){
//     let token = localStorage.getItem('token');
//     // const token = getItem('token');
//     var auth = setContext((operation, context) => ({
//       headers: {
//         Authorization: `Bearer ${token}`
//       },
//     }));
  
//   } else {
//     var auth = setContext((operation, context) => ({
//       headers: {
//       },
//     }));
//   }


//   const link = ApolloLink.from([basic, auth, httpLink.create({ uri })]);
//   const cache = new InMemoryCache();

//   return {
//     link,
//     cache
//   }

 
// }

// import { setContext } from 'apollo-link-context';

// const auth = setContext(async(_, { headers }) => {
//   // Grab token if there is one in storage or hasn't expired
//   let token = this.auth.getCachedAccessToken();

//   if (!token) {
//     // An observable to fetch a new token
//     // Converted .toPromise()
//     await this.auth.acquireToken().toPromise();

//     // Set new token to the response (adal puts the new token in storage when fetched)
//     token = this.auth.getCachedAccessToken();
//   }
//   // Return the headers as usual
//   return {
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   };
// });

@NgModule({
  exports: [
    HttpClientModule,
    ApolloModule,
    HttpLinkModule
  ],
  providers: [{
    provide: APOLLO_OPTIONS,
    useFactory: creatApollo,
    deps: [HttpLink, AngularFireAuth]
  }]
})
export class GraphQLModule {}